import { Box } from '@mui/material';
import React from 'react';

export interface TimeBrushHoverContentProps {
  readonly ts: number;
}

interface TimeBrushHoverOverlayProps {
  readonly hoveredTs: number | null;
  readonly hoveredX: number | null;
  readonly parentWidth: number;
  readonly parentHeight: number;
  readonly HoverContentComponent?: React.ComponentType<TimeBrushHoverContentProps>;
}

/**
 * Renders parent-defined hover content inside the brush SVG using foreignObject.
 * The content is centered horizontally on the current hover X coordinate.
 */
export function TimeBrushHoverOverlay({
  hoveredTs,
  hoveredX,
  parentWidth,
  parentHeight,
  HoverContentComponent,
}: TimeBrushHoverOverlayProps) {
  if (!HoverContentComponent || hoveredTs === null || hoveredX === null) {
    return null;
  }

  return (
    <foreignObject
      x={0}
      y={0}
      width={parentWidth}
      height={parentHeight}
      style={{ pointerEvents: 'none' }}
    >
      <Box
        sx={{
          position: 'relative',
          width: `${parentWidth}px`,
          height: `${parentHeight}px`,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: `${hoveredX}px`,
            top: 0,
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          <HoverContentComponent ts={hoveredTs} />
        </Box>
      </Box>
    </foreignObject>
  );
}
